import * as i0 from '@angular/core';
import { Injectable, Inject, Component, NgModule } from '@angular/core';
import * as i4 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i5 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i6 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import * as i7 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i2 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i8 from '@azavista/components/button';
import { AzavistaButtonModule } from '@azavista/components/button';
import { AzavistaSharedModule } from '@azavista/components/shared';
import * as i3 from '@angular/common';
import * as i9 from '@ngx-translate/core';
function AzavistaMultiSelectDialogComponent_mat_list_option_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-list-option", 13)(1, "mat-icon", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "h4", 15)(4, "b");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "p", 16);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "p", 16)(9, "i");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r2)("selected", item_r2.selected);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r2.icon);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r2.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r2.description);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r2.example);
  }
}
let AzavistaMultiSelectDialogService = /*#__PURE__*/(() => {
  class AzavistaMultiSelectDialogService {
    getFilteredItems(allItems, searchText) {
      let filteredItems;
      const searchTextLowercased = (searchText || '').trim().toLowerCase();
      if (!searchTextLowercased) {
        filteredItems = [...allItems];
      } else {
        filteredItems = allItems.filter(x => {
          const titleLowercased = (x.title || '').trim().toLowerCase();
          if (titleLowercased && titleLowercased.indexOf(searchTextLowercased) >= 0) {
            return true;
          }
          const descriptionLowercased = (x.description || '').trim().toLowerCase();
          if (descriptionLowercased && descriptionLowercased.indexOf(searchTextLowercased) >= 0) {
            return true;
          }
          return false;
        });
      }
      return filteredItems;
    }
    static {
      this.ɵfac = function AzavistaMultiSelectDialogService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaMultiSelectDialogService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AzavistaMultiSelectDialogService,
        factory: AzavistaMultiSelectDialogService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AzavistaMultiSelectDialogService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaMultiSelectDialogComponent = /*#__PURE__*/(() => {
  class AzavistaMultiSelectDialogComponent {
    constructor(multiSelectDialogSvc, matDialogRef, data) {
      this.multiSelectDialogSvc = multiSelectDialogSvc;
      this.matDialogRef = matDialogRef;
      this.data = data;
    }
    ngOnInit() {
      this.filteredItems = [...this.data.items];
    }
    searchTextChanged(searchText) {
      this.filteredItems = this.multiSelectDialogSvc.getFilteredItems(this.data.items, searchText);
    }
    onSelectionChange(change) {
      if (this.data.singleSelection) {
        // Single selection only - remove all selected so only this one will become selected
        this.data.items.forEach(x => x.selected = false);
      }
      const item = this.data.items.find(x => x === change.options[0].value);
      if (item) {
        item.selected = change.options[0].selected;
      }
    }
    onCancelClick() {
      this.matDialogRef.close();
    }
    onSaveClick() {
      this.matDialogRef.close(this.data);
    }
    static {
      this.ɵfac = function AzavistaMultiSelectDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaMultiSelectDialogComponent)(i0.ɵɵdirectiveInject(AzavistaMultiSelectDialogService), i0.ɵɵdirectiveInject(i2.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaMultiSelectDialogComponent,
        selectors: [["ng-component"]],
        standalone: false,
        decls: 25,
        vars: 18,
        consts: [["selectionList", ""], ["mat-dialog-title", "", 1, "aza-cmp-dialog-title"], ["mat-dialog-content", ""], [1, "aza-cmp-subtitle"], [1, "aza-cmp-full-width", 3, "floatLabel"], ["matPrefix", ""], ["matInput", "", "type", "text", 3, "input", "placeholder"], ["mat-dialog-content", "", 1, "aza-cmp-dialog-content"], ["color", "primary", 3, "selectionChange", "multiple"], [3, "value", "selected", 4, "ngFor", "ngForOf"], ["mat-dialog-actions", "", 1, "aza-cmp-dialog-actions"], ["color", "primary", 1, "aza-cmp-dialog-action-cancel-button", 3, "click"], ["color", "primary", 1, "aza-cmp-dialog-action-apply-button", 3, "click"], [3, "value", "selected"], ["matListItemIcon", ""], ["matListItemTitle", ""], ["matListItemLine", ""]],
        template: function AzavistaMultiSelectDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "h1", 1);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 2)(3, "p", 3);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "mat-form-field", 4)(6, "mat-icon", 5);
            i0.ɵɵtext(7, "search");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "input", 6);
            i0.ɵɵpipe(9, "translate");
            i0.ɵɵlistener("input", function AzavistaMultiSelectDialogComponent_Template_input_input_8_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.searchTextChanged($event.target.value));
            });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(10, "div", 7)(11, "mat-selection-list", 8, 0);
            i0.ɵɵlistener("selectionChange", function AzavistaMultiSelectDialogComponent_Template_mat_selection_list_selectionChange_11_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSelectionChange($event));
            });
            i0.ɵɵtemplate(13, AzavistaMultiSelectDialogComponent_mat_list_option_13_Template, 11, 6, "mat-list-option", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "div", 10)(15, "azavista-flat-button", 11);
            i0.ɵɵlistener("click", function AzavistaMultiSelectDialogComponent_Template_azavista_flat_button_click_15_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onCancelClick());
            });
            i0.ɵɵelementStart(16, "span");
            i0.ɵɵtext(17);
            i0.ɵɵpipe(18, "translate");
            i0.ɵɵpipe(19, "uppercase");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(20, "azavista-button", 12);
            i0.ɵɵlistener("click", function AzavistaMultiSelectDialogComponent_Template_azavista_button_click_20_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSaveClick());
            });
            i0.ɵɵelementStart(21, "span");
            i0.ɵɵtext(22);
            i0.ɵɵpipe(23, "translate");
            i0.ɵɵpipe(24, "uppercase");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.data.title);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.data.subTitle);
            i0.ɵɵadvance();
            i0.ɵɵproperty("floatLabel", "never");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(9, 8, "SEARCH"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("multiple", false);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.filteredItems);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 12, i0.ɵɵpipeBind1(18, 10, "CANCEL")));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(24, 16, i0.ɵɵpipeBind1(23, 14, "SAVE")));
          }
        },
        dependencies: [i3.NgForOf, i4.MatFormField, i4.MatPrefix, i5.MatIcon, i6.MatSelectionList, i6.MatListOption, i6.MatListItemIcon, i6.MatListItemLine, i6.MatListItemTitle, i7.MatInput, i8.AzavistaButtonComponent, i8.AzavistaFlatButtonComponent, i2.MatDialogTitle, i2.MatDialogActions, i2.MatDialogContent, i3.UpperCasePipe, i9.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return AzavistaMultiSelectDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaMultiSelectDialogModule = /*#__PURE__*/(() => {
  class AzavistaMultiSelectDialogModule {
    static {
      this.ɵfac = function AzavistaMultiSelectDialogModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaMultiSelectDialogModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AzavistaMultiSelectDialogModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [AzavistaSharedModule, MatFormFieldModule, MatIconModule, MatListModule, MatInputModule, AzavistaButtonModule, MatDialogModule]
      });
    }
  }
  return AzavistaMultiSelectDialogModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AzavistaMultiSelectDialogComponent, AzavistaMultiSelectDialogModule };
